import { Button } from '@hotjar/hotsauce';
import { ProductType } from '@hotjar/webapp/domains/common/product/types';
import { useTranslationWithPrefix } from '@hotjar/translations';
import type { SelectedProductTypes } from '@hotjar/webapp/features/Billing/MultiProductUpsellModals/MultiProductWrapper/hooks/useMultiProductsState';
import type { Site } from '@hotjar/site';
import type { CurrentUser } from '@hotjar/user';
import { getSalesLink } from '@hotjar/upsell';
import { ProductSelectActionsStyles as S } from './ProductSelectActions.styles';

interface Props {
  selectedProductTypes: SelectedProductTypes;
  onContinueClick: () => void;
  currentSite: Site | undefined;
  currentUser: CurrentUser | undefined;
}

export const ProductSelectActions = ({
  selectedProductTypes,
  onContinueClick,
  currentSite,
  currentUser,
}: Props): JSX.Element => {
  const { t } = useTranslationWithPrefix('billing:product-select-upsell-modal');

  let labelKey = 'cta-continue-none-selected';
  let isDisabled = true;
  if (selectedProductTypes[ProductType.Analytics] && selectedProductTypes[ProductType.Feedback]) {
    labelKey = 'cta-continue-both-selected';
    isDisabled = false;
  } else if (selectedProductTypes[ProductType.Analytics]) {
    labelKey = 'cta-continue-observe-selected';
    isDisabled = false;
  } else if (selectedProductTypes[ProductType.Feedback]) {
    labelKey = 'cta-continue-ask-selected';
    isDisabled = false;
  }

  const isOrganizationBiggerThan50 =
    currentSite?.organization?.size !== '1-10' && currentSite?.organization?.size !== '11-50';
  const userRole = currentUser?.role ?? 'other';
  const userCanContactSales =
    (userRole === 'product manager' || userRole === 'ux designer') && isOrganizationBiggerThan50;

  return (
    <div>
      <Button
        type="submit"
        onClick={onContinueClick}
        kind={userCanContactSales ? 'ghost' : 'primary'}
        isDisabled={isDisabled}
      >
        {t(labelKey)}
      </Button>
      {userCanContactSales && (
        <S.BookACallButton
          type="submit"
          kind="primary"
          as="a"
          href={getSalesLink('MultiProductUpsell')}
          isExternal
        >
          {t('cta-book-a-call')}
        </S.BookACallButton>
      )}
    </div>
  );
};
